<div class="basket-container" *ngIf="basket$ | async as basket">
  <div class="content" *ngIf="basket.entries.length > 0; else noEntries">
    <div class="header">
      <h1 class="title">
        {{ 'basket.headline' | translate }}
      </h1>
      <div class="action">
        <kion-button mode="primary" [title]="'basket.button.buy' | translate" [isLink]="true" [link]="checkoutLink"></kion-button>
      </div>
    </div>
    <div class="body">
      <kion-basket-list
        [entries]="basket.entries"
        [isMultiVendor]="isMultiVendor$ | async"
        (quantityChanged)="quantityChanged($event)"
        (delete)="deleteEntry($event)"
      ></kion-basket-list>
    </div>
    <div class="footer">
      <div class="sub">
        <div class="voucher" [formGroup]="form">
          <p class="label">{{ 'basket.label.voucher' | translate }}</p>
          <label for="voucher"></label>
          <input type="text" id="voucher" class="{{ (voucherError$ | async) ? 'failed' : '' }}" [placeholder]="'basket.placeHolder.voucher' | translate" formControlName="voucher"/>
          <p class="error" *ngIf="voucherError$ | async">
            {{ 'basket.error.voucher' | translate  }}
          </p>
        </div>
        <div class="summary">
          <kion-basket-summary [price]="pricing$ | async"></kion-basket-summary>
        </div>
      </div>
      <div class="action">
        <div class="back">
          <kion-label-button [title]="'basket.button.continue' | translate" link="/">
            <svg img-link xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
              <path fill="#9B9B9E" fill-rule="evenodd" d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z" transform="translate(.571 2.857)"></path>
            </svg>
          </kion-label-button>
        </div>
        <div class="forward">
          <kion-button mode="primary" [title]="'basket.button.buy' | translate" [isLink]="true" [link]="checkoutLink"></kion-button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noEntries>
    <div class="noResult">
      <svg viewBox="0 0 200 45" class="slope">
        <path d="M 0,12 200,0 v 45 H 0 Z"></path>
      </svg>
      <div class="maincontainer">
        <kion-label-button [title]="'basket.button.continue' | translate" link="/">
          <svg img-link xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
            <path fill="#9B9B9E" fill-rule="evenodd" d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z" transform="translate(.571 2.857)"></path>
          </svg>
        </kion-label-button>
        <kion-headline-tag [title]="'basket.noResult.headline' | translate"></kion-headline-tag>
        <div class="wrap">
          <div class="text">
            <div class="description">
              {{ 'basket.noResult.description' | translate }}
            </div>
          </div>
          <div class="imgcontainer">
            <img
              lazyLoad="./assets/background/order_confirmation_background.png"
              defaultImage="./assets/background/order_confirmation_background.png"
              errorImage="./assets/ui/shared/error/not_found_error_image.png"
              alt="no_result"
              title="no_result"
              src="#"
            />
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
